import React from "react";
import { Navigate } from "react-router-dom";
import { PublicAuthRoutes } from "../features/auth/routes";
import { PublicAssignmentRoutes } from "../features/assignment/routes";
import { PublicQuizRoutes } from "../features/quiz/routes";
import { PublicDemoRoutes } from "../features/demo/routes";

export const publicRoutes = [
  {
    path: "/auth/*",
    element: <PublicAuthRoutes />,
  },
  {
    path: "/assignments/*",
    element: <PublicAssignmentRoutes />,
  },
  {
    path: "/quizzes/*",
    element: <PublicQuizRoutes />,
  },
  {
    path: "/demo/*",
    element: <PublicDemoRoutes />,
  },
  {
    path: "*",
    element: <Navigate to="/auth/login" />,
  },
];
